import { WEEKS, WEEKS_LONG, MONTHS } from "@/constants/calendar";
import STATUS_CONFIG from "@/constants/statuses";
import { toRUDate } from '@/utilities';

import Appointment from "./Appointment";
import Client from "./Client";
import Notary from "./Notary";
import ApiService from "../ApiService";


class AppointmentRequest {
  constructor(data, code) {
    this.id = data.id;
    this.code = code;
    // this.appointment = new Appointment(data.appointment);
    // если указан, то заявка отправлена нотариусу
    this.appointment_created_id = data.appointment_created_id;
    this.datetime = new Date(data.slot_datetime);
    this.notary = new Notary(data.notary || {});

    this.subject = data.service_name;
    this.comment = data.comment;
    this.file_url = data.file_url;
    this.book_id = data.book_id;

    // TODO:
    this.is_archived = false;
    // TODO: some legacy and new code
    this.status_comment = data.status;
    this.status_code = data.status_code || null;
    this.status = this._getStatus();

    this.client = new Client({
      fio: data.fio,
      email: data.email,
      phone: data.phone,
      is_client: true
    });
    this.is_user_registered = data.is_user_registered;
  }

  async confirmAppointment() {
    return await ApiService.post(`/appointment-request/${this.code}/confirm/`);
  }

  async cancelAppointment() {
    return await ApiService.delete(`/appointment-request/${this.code}/`);
  }

  /**
   * TODO: how to check?
   */
  checkIsArchived() {
    return false;
  }

  /**
   * Returns status config
   * -2 Отменена клиентом
   * -1 Отменена нотариусом (не используется)
   * 0 Ожидает подтверждения (черновик)
   * 1 Подтверждена (отправлена нотариусу)
   * 10 Зарезервирована (не используется)
   * @returns {{text: string, color: string, disabled: boolean, bordered: boolean}}
   */
  getStatusConfig() {
    return STATUS_CONFIG[this.status];
  }

  getDateTime() {
    return `${this.getDate()} ${this.getTime()}`;
  }

  /**
   * Returns date in locale date string format
   */
  getDate() {
    return toRUDate(this.datetime);
  }

  getTime() {
    return this.datetime.toTimeString().substring(0, 5);
  }

  /**
   * Returns week name in long and abbreviated format
   */
  getWeek() {
    return {
      weekDayLong: WEEKS_LONG[this.datetime.getDay()].toLowerCase(),
      weekDay: WEEKS[this.datetime.getDay()]
    };
  }

  /**
   * Returns date in day with month format
   */
  getDay() {
    return this.datetime.toLocaleString("ru", {
      month: "long",
      day: "numeric"
    });
  }

  _getStatus() {
    // статус по умолчанию
    let status = 0;

    if (this.status_code) {
      status = this.status_code;
    }

    // TODO: check for client cancelation

    return status;
  }
}

export default AppointmentRequest;
